import React, { useState } from 'react'
import { Card, Typography, Button, Row, Col } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import axiosInstance from '../Utils/axiosInstance'
import { GenerateQR, PdfPath } from "../API's/UserApi"
import { toast } from 'react-toastify'

const { Title, Text } = Typography

const PaymentPage = () => {
  const location = useLocation()
  const slot = location.state?.slot
  const navigate = useNavigate()

  const [qrCode, setQrCode] = useState(null)
  const [loading, setLoading] = useState(false)

  //   const handleGenerateQR = async () => {
  //     try {
  //       setLoading(true)

  //       const userData = JSON.parse(sessionStorage.getItem('userData'))
  //       const mobileNo = userData?.mobileNo
  //       const userType = userData?.userType

  //       const bookingDate = new Date().toISOString().split('T')[0]

  //       const res = await axiosInstance.post(GenerateQR, {
  //         mobileNo: mobileNo,
  //         slotId: slot.id,
  //         userType: userType,
  //         bookingDate: bookingDate,
  //         paymentMode: 'Cash',
  //       })

  //       if (res.data === 'SLOT_NOT_FOUND') {
  //         toast.warn('Slot Not Found')
  //       } else if (res.data.message === 'BOOKING_CONFIRMED') {
  //         const pdfUrl = `${PdfPath}${res.data.pdfName}`

  //         window.open(pdfUrl, '_blank')

  //         // navigate('/user/qr-view', {
  //         //   state: {
  //         //     qrPdf: pdfUrl,
  //         //   },
  //         // })

  //       } else if (res.data == 'ALREADY_BOOKED') {
  //         toast.warn('Already slot booked !')
  //       }
  //     } catch (error) {
  //       console.error('QR API Error', error)
  //     } finally {
  //       setLoading(false)
  //     }
  //   }

  const handleGenerateQR = async () => {
    try {
      setLoading(true)

      const userData = JSON.parse(sessionStorage.getItem('userData'))
      const mobileNo = userData?.mobileNo
      const userType = userData?.userType

      const bookingDate = new Date().toISOString().split('T')[0]

      const res = await axiosInstance.post(GenerateQR, {
        mobileNo: mobileNo,
        slotId: slot.id,
        userType: userType,
        bookingDate: bookingDate,
        paymentMode: 'Cash',
      })

      const data = res.data

      if (data.message === 'SLOT_NOT_FOUND') {
        toast.warn('Slot Not Found')
      } else if (data === 'ALREADY_BOOKED') {
        toast.warn('Already slot booked!')
      } else if (data.message === 'BOOKING_CONFIRMED') {
        toast.success('Slot booked successfully')

        navigate('/user/qr-view', {
          state: {
            qrData: data,
          },
        })
      }
    } catch (error) {
      console.error('QR API Error', error)
    } finally {
      setLoading(false)
    }
  }
  const handleCancel = () => {
    navigate('/user/user-bookslot')
  }

  return (
    <div className="payment-container">
      <Card className="payment-card">
        <Title
          className="login-title"
          level={3}
          style={{ textAlign: 'center' }}
        >
          Payment Details
        </Title>

        <Row gutter={[16, 16]}>
          <Col xs={24} md={6} lg={8}></Col>
          <Col xs={24} md={12} lg={8}>
            <Row
              gutter={[16, 16]}
              className="border p-4 rounded"
              style={{ backgroundColor: '#d2eaff' }}
            >
              <Col sm={24}>
                <Text strong>Time From:</Text> {slot?.timeFrom}
              </Col>

              <Col sm={24}>
                <Text strong>Time To:</Text> {slot?.timeTo}
              </Col>

              <Col sm={24}>
                <Text strong>Available Intake:</Text> {slot?.intakeAvailable}
              </Col>

              <Col sm={24}>
                <Text strong>Payment Amount (Rs.) :</Text> 90
              </Col>
            </Row>

            <Row gutter={16} justify="center" style={{ marginTop: 30 }}>
              <Col xs={24} sm={12} md={8} className="pt-2">
                <Button block size="large" onClick={handleCancel}>
                  Cancel
                </Button>
              </Col>
              <Col xs={24} sm={12} md={8} className="pt-2">
                <Button
                  type="primary"
                  block
                  size="large"
                  loading={loading}
                  onClick={handleGenerateQR}
                >
                  Pay Now
                </Button>
              </Col>
            </Row>
          </Col>
          <Col xs={24} md={6} lg={8}></Col>
        </Row>
      </Card>
    </div>
  )
}

export default PaymentPage
